import { NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { DateTimeHelperService } from '../../date-time-helper/date-time-helper.service';
import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class DateTimeControl extends FormControlBase<string> {
  private dateTimehelper: DateTimeHelperService = new DateTimeHelperService();
  public controlType = 'datetime';
  public maxDate: Date;
  public orientation: string = 'auto';
  public showClearButton: boolean = false;

  constructor(options: FormControlData<string> = {}, form: NgForm = null) {
    super(options, form);
    this.orientation = options.orientation || 'auto';

    this.showClearButton = options?.showClearButton || false;
  }

  protected initialize() {
    const value: string = _.get(this.model, this.propertyName) as string;

    this.value = this.dateTimehelper.isValidDateString(value) ? value : '';
  }

  public commit() {
    if (this.value === '') {
      _.set(this.model, this.propertyName, undefined);
    } else {
      _.set(this.model, this.propertyName, this.value);
    }
  }
}
